export var CONTROL = {
  Object: 'object',
  Array: 'array',
  ToggleObject: 'toggle-object',
  SelectSingle: 'select-single',
  SelectMultiple: 'select-multiple',
  Segmented: 'segmented',
  Carousel: 'carousel',
  Toggle: 'toggle',
  ToggleCards: 'toggle-cards',
  Stepper: 'stepper',
  Alert: 'alert',
  Table: 'table',
  Slider: 'slider',
  StepperWithValues: 'stepper-with-values'
};